export default {"src":"/_next/static/media/area_visits_1.134d1ea0.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};